export enum FormatType {
    JSON = "JSON",
    TXT = "TXT",
    CSV = "CVS",
    XML = "XML"
}


export class ParserType {
    public id: number;
    formatType: FormatType;
    identifier: string;

    invoiceTemplate: string;
    ticketTemplate: string;
    debitNoteTemplate: string;
    creditNoteTemplate: string;
    perceptionTemplate: string;
    retentionTemplate: string;
    despatchAdviceTemplate: string;
    summaryDocumentTemplate: string;
    raVoidadDocumentTemplate: string;
    rrVoidadDocumentTemplate: string;

    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;

    constructor(id: number = null,
                formatType: FormatType = FormatType.JSON,
                identifier: string = "Seleccione una tipo de Tranformación",
                invoiceTemplate: string = "",
                ticketTemplate: string = "",
                debitNoteTemplate: string = "",
                creditNoteTemplate: string = "",
                perceptionTemplate: string = "",
                retentionTemplate: string = "",
                despatchAdviceTemplate: string = "",
                summaryDocumentTemplate: string = "",
                raVoidadDocumentTemplate: string = "",
                rrVoidadDocumentTemplate: string = "",
                logEstatusRegistro: string = "",
                logUsernameRegistro: string = "",
                logFechaRegistro: string = "",
                logUsernameModificacion: string = "",
                logFechaModificacion: string = "") {
        this.id = id;
        this.formatType = formatType;
        this.identifier = identifier;

        this.invoiceTemplate = invoiceTemplate;
        this.ticketTemplate = ticketTemplate;
        this.debitNoteTemplate = debitNoteTemplate;
        this.creditNoteTemplate = creditNoteTemplate;
        this.perceptionTemplate = perceptionTemplate;
        this.retentionTemplate = retentionTemplate;
        this.despatchAdviceTemplate = despatchAdviceTemplate;
        this.summaryDocumentTemplate = summaryDocumentTemplate;
        this.raVoidadDocumentTemplate = raVoidadDocumentTemplate;
        this.rrVoidadDocumentTemplate = rrVoidadDocumentTemplate;

        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;

    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/ParserType.ts